const getters = {
    appState: state => state.app,
    routers: state => state.router.routers,
    userInfo: state => state.user.userInfo,
    visitedViews: state => state.tagsView.visitedViews,
    menuRemindNum: state => {
        return state.menuRemind.menuRemindNum;
    },
    navNumData: state => {
        return state.menuRemind.navNumData;
    },
	workPlantEntry:state =>{
		return state.workPlantEntry.workPlantEntry;
	},
    showLeft:state=>{
        return state.showLeft.showLeft;
    },
    layoutType:state=>{
        return state.showLeft.layoutType;
    },
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js